import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Divider, Spinner } from '@telus-uds/components-web';
import { FileUpload as UDSFileUpload } from '@telus-uds/components-base';

import request from '../../../../../utils/request';
import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';

const FileUpload = ({ addFileToList, orderId }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    general: {
      fileUploadingError,
      uploading
    }
  } = localizedStrings;
  const [isUploading, setIsUploading] = useState(false);

  const handleUpload = async (files) => {
    setIsUploading(true);
    const results = await Promise.all(files.map(async (file) => {
      try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('typeId', 0);
        const result = await request.post(`/orders/${orderId}/upload-file`, formData);
        if (result) {
          addFileToList(result.data.orderFile);
        }
        return file;
      } catch (error) {
        return { name: file.name, error: fileUploadingError };
      }
    }));
    setIsUploading(false);
    return results;
  };

  const handleDelete = async () => ({});

  return (
    <>
      <Divider space={2} variant={{ inverse: true }} />
      <Spinner label={uploading} variant={{ size: 'small' }} show={isUploading} inline>
        <UDSFileUpload
          fileTypes={['pdf']}
          maxFileSize={5}
          onUpload={handleUpload}
          onDelete={handleDelete}
        />
      </Spinner>
    </>
  );
};

FileUpload.propTypes = {
  addFileToList: PropTypes.func.isRequired,
  orderId: PropTypes.number.isRequired
};

export default FileUpload;
